import type { Card } from "@feed/shared";

// Appends a later page, skipping cards already shown (a poll can land between two pages).
export function appendPage(shown: Card[], page: Card[]): Card[] {
  const have = new Set(shown.map((card) => card.id));
  return [...shown, ...page.filter((card) => !have.has(card.id))];
}

// Cards in the freshest page that the reader has not seen yet.
export function unseen(shown: Card[], freshest: Card[]): Card[] {
  const have = new Set(shown.map((card) => card.id));
  return freshest.filter((card) => !have.has(card.id));
}

// Puts new cards on top without disturbing the rest.
export function prependNew(shown: Card[], fresh: Card[]): Card[] {
  return [...unseen(shown, fresh), ...shown];
}

export function replaceCard(shown: Card[], card: Card): Card[] {
  return shown.map((item) => (item.id === card.id ? card : item));
}
